import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { axiosPost } from "../../Helpers";
import ViewSpecificUserModalView from "../modalViews";
import AddUsers from "./addUser";
import { loadRoles, loadUsers } from "./loadData";
import { usersHeaders } from "./tableHeaders";

const ViewUsers = (props) => {
  const [cancelled, setCancelled] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  console.log("this is editData", editData);
  console.log("this is delete data", deleteData);
  console.log("this is delete modal state", deleteModalState);
  //change role to role.name
  users.map((user) => {
    user.userRole = user.role?.name || "No Role";
  });
  useEffect(() => {
    loadUsers(props.userType, setLoading).then(setUsers);
    loadRoles(setLoading).then(setUserRoles);
  }, [location.pathname, update]);
  console.log(users);

  return (
    <AdminPage title="View Users">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"User Details"}
        InternalComponent={<ViewSpecificUserModalView user={viewModalData} />}
      />
      {/* <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Industry"}
        InternalComponent={
          <DeleteModalContent
            route={`industry/deleteIndustry/${deleteData?._id}`}
            type={"Industry"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      /> */}
      <AddUsers
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        userRoles={userRoles}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          cancelled={cancelled}
          setCancelled={setCancelled}
          axiosFunction={axiosPost}
          blockURL={"user/blockUser"}
          unblockURL={"user/unBlockUser"}
          blockingParam={"blockUserId"}
          //Logic for blocking the user ^^ (for now)
          showAddButton={true}
          headCells={usersHeaders}
          rowData={users}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          opened={opened}
          setOpened={setOpened}
          //
          setUpdate={setUpdate}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default ViewUsers;
